/**
 * LUXIRE v2 — Product Page JS
 * Clean build. All show/hide via CSS classes.
 * Every module: init() + methods. No cross-module calls except Pricing.
 */
(function() {
  'use strict';

  var Luxire = window.Luxire || {};
  window.Luxire = Luxire;


  /* ═══════════════════════
     GALLERY
     Click-to-lightbox only. Touch swipe on mobile.
     ═══════════════════════ */

  Luxire.Gallery = {
    idx: 0,
    slides: [],
    thumbs: [],
    dots: [],
    fullSrcs: [],

    init: function() {
      this.slides = [].slice.call(document.querySelectorAll('.product-gallery__slide'));
      this.thumbs = [].slice.call(document.querySelectorAll('.product-gallery__thumb'));
      this.dots   = [].slice.call(document.querySelectorAll('.product-gallery__dot'));
      if (!this.slides.length) return;

      this.fullSrcs = this.slides.map(function(s) {
        return s.dataset.fullSrc || s.querySelector('img').src;
      });

      var self = this;

      /* Thumb clicks */
      this.thumbs.forEach(function(t) {
        t.addEventListener('click', function() { self.goTo(+t.dataset.thumbIndex); });
      });

      /* Click main image or zoom button → lightbox */
      var main = document.querySelector('[data-gallery-main]');
      if (main) main.addEventListener('click', function(e) {
        if (e.target.closest('.product-gallery__zoom-btn') || e.target.tagName === 'IMG') {
          e.preventDefault();
          self.openLightbox();
        }
      });

      /* Lightbox controls */
      document.querySelectorAll('[data-close-lightbox]').forEach(function(b) {
        b.addEventListener('click', function() { self.closeLightbox(); });
      });
      var prev = document.querySelector('[data-lightbox-prev]');
      var next = document.querySelector('[data-lightbox-next]');
      if (prev) prev.addEventListener('click', function(e) { e.stopPropagation(); self.lbNav(-1); });
      if (next) next.addEventListener('click', function(e) { e.stopPropagation(); self.lbNav(1); });

      /* Keyboard */
      document.addEventListener('keydown', function(e) {
        var lb = document.querySelector('.product-lightbox.is-open');
        if (!lb) return;
        if (e.key === 'Escape') self.closeLightbox();
        if (e.key === 'ArrowLeft')  self.lbNav(-1);
        if (e.key === 'ArrowRight') self.lbNav(1);
      });

      /* Mobile swipe */
      if (main) this._initSwipe(main);
    },

    goTo: function(i) {
      if (!this.slides.length) return;
      if (i < 0) i = this.slides.length - 1;
      if (i >= this.slides.length) i = 0;
      this.idx = i;
      this.slides.forEach(function(s, n) { s.classList.toggle('is-active', n === i); });
      this.thumbs.forEach(function(t, n) { t.classList.toggle('is-active', n === i); });
      this.dots.forEach(function(d, n)   { d.classList.toggle('is-active', n === i); });
      if (this.thumbs[i]) this.thumbs[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    },

    _initSwipe: function(el) {
      var self = this, x0 = 0, dx = 0;
      el.addEventListener('touchstart', function(e) { x0 = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchmove',  function(e) { dx = e.touches[0].clientX - x0; }, { passive: true });
      el.addEventListener('touchend', function() {
        if (Math.abs(dx) > 50) dx < 0 ? self.goTo(self.idx + 1) : self.goTo(self.idx - 1);
        dx = 0;
      });
    },

    openLightbox: function() {
      var lb = document.querySelector('[data-lightbox]');
      if (!lb) return;
      lb.classList.add('is-open');
      this._updateLbImg();
      document.body.classList.add('is-scroll-locked');
    },

    closeLightbox: function() {
      var lb = document.querySelector('[data-lightbox]');
      if (!lb) return;
      lb.classList.remove('is-open');
      document.body.classList.remove('is-scroll-locked');
    },

    lbNav: function(dir) {
      var n = this.idx + dir;
      if (n < 0) n = this.slides.length - 1;
      if (n >= this.slides.length) n = 0;
      this.goTo(n);
      this._updateLbImg();
    },

    _updateLbImg: function() {
      var img = document.querySelector('[data-lightbox-img]');
      var ctr = document.querySelector('[data-lightbox-counter]');
      if (img) img.src = this.fullSrcs[this.idx] || '';
      if (ctr) ctr.textContent = (this.idx + 1) + ' / ' + this.slides.length;
    }
  };


  /* ═══════════════════════
     THE FORK
     ═══════════════════════ */

  Luxire.Fork = {
    currentTrack: 'as-shown',

    init: function() {
      var fork = document.querySelector('[data-fork]');
      if (!fork) return;

      /* Suit-basic / shirt-jacket: fork is fixed, no options to toggle */
      if (fork.dataset.forkFixed) {
        this.currentTrack = fork.dataset.forkFixed;
        return;
      }

      var self = this;
      fork.querySelectorAll('[data-fork-option]').forEach(function(opt) {
        opt.addEventListener('click', function() { self.setTrack(opt.dataset.forkOption); });
      });

      /* Add step-label span (hidden until collapsed) */
      var custTitle = fork.querySelector('[data-fork-option="customize"] .product-fork__title');
      if (custTitle && !custTitle.querySelector('.product-fork__step-label')) {
        var lbl = document.createElement('span');
        lbl.className = 'product-fork__step-label';
        lbl.setAttribute('data-fork-step-label', '');
        custTitle.appendChild(lbl);
      }
    },

    setTrack: function(track) {
      this.currentTrack = track;

      document.querySelectorAll('[data-fork-option]').forEach(function(opt) {
        opt.classList.toggle('product-fork__option--active', opt.dataset.forkOption === track);
      });

      /* Show/hide customizer via .is-hidden */
      var cz = document.querySelector('[data-track="customize"]');
      if (cz) cz.classList.toggle('is-hidden', track !== 'customize');

      Luxire.Pricing.updateProperties();
    },

    /** Called by Wizard.goTo to update the collapsed step label */
    updateStepLabel: function(step, total) {
      var lbl = document.querySelector('[data-fork-step-label]');
      if (lbl) lbl.textContent = ' · Step ' + step + ' of ' + total;
    }
  };


  /* ═══════════════════════
     WIZARD
     ═══════════════════════ */

  Luxire.Wizard = {
    step: 1,
    total: 0,
    selections: {},
    userTouched: {},  /* tracks which properties the customer explicitly selected */

    /** Step descriptions for the C-style banner */
    stepDescs: {
      /* Pants */
      'Front Pleats': 'How fabric folds below the waistband',
      'Front Pockets': 'Choose your pocket style',
      'Fly Style': 'Button fly or zip fly',
      'Waistband': 'Choose how your trousers sit at the waist',
      'Front Closure': 'How the front of your trousers fastens',
      'Rear Pockets': 'Pockets at the back',
      'Lining': 'Interior lining options',
      'Bottom / Cuff': 'Hem and cuff finishing',
      /* Shirts */
      'Collar': 'Frames your face and sets the shirt\'s character',
      'Cuffs': 'How the sleeve ends — barrel or French',
      'Placket': 'The front closure strip that holds buttons',
      'Pocket (Left)': 'Optional chest pocket on the left',
      'Pocket (Right)': 'Optional chest pocket on the right',
      'Back': 'How the back panel is constructed',
      'Yoke': 'The shoulder piece connecting front and back',
      'Bottom / Hem': 'How the shirt hem is finished',
      'Gusset': 'Reinforcement at the side seam split',
      'Buttons': 'Button material and style',
      /* Jacket */
      'Lapel': 'Defines the jacket\'s character and formality',
      'Chest Pocket': 'The breast pocket on the upper left',
      'Hip Pocket': 'The lower pockets on each side',
      'Vents': 'Slits at the back hem for movement',
      'Construction': 'How the jacket\'s structure is built',
      /* Suit — prefixed property names */
      'Jacket - Lapel': 'Defines the jacket\'s character and formality',
      'Jacket - Chest Pocket': 'The breast pocket on the upper left',
      'Jacket - Hip Pocket': 'The lower pockets on each side',
      'Jacket - Vents': 'Slits at the back hem for movement',
      'Jacket - Lining': 'Interior jacket lining options',
      'Jacket - Construction': 'How the jacket\'s structure is built',
      'Trousers - Front Pleats': 'Folds of fabric below the waistband',
      'Trousers - Front Pockets': 'How the side pockets are styled',
      'Trousers - Fly Style': 'How the trouser fly operates',
      'Trousers - Waistband': 'Choose how your trousers sit at the waist',
      'Trousers - Front Closure': 'How the front of your trousers fastens',
      'Trousers - Rear Pockets': 'Pockets at the back',
      'Trousers - Lining': 'Interior trouser lining options',
      'Trousers - Bottom Style': 'Hem and cuff finishing'
    },

    init: function() {
      var wiz = document.querySelector('[data-wizard]');
      if (!wiz) return;
      var self = this;
      this.total = wiz.querySelectorAll('[data-wizard-step]').length;

      /* Option clicks */
      wiz.querySelectorAll('[data-option]').forEach(function(opt) {
        opt.addEventListener('click', function() {
          self._selectOption(opt);
        });
      });

      /* Nav: next */
      wiz.querySelectorAll('[data-wizard-next]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          /* Validate: must select an option before proceeding */
          var currentStep = wiz.querySelector('[data-wizard-step="' + self.step + '"]');
          if (currentStep) {
            var prop = currentStep.dataset.stepProperty;
            if (!self.selections[prop]) {
              /* No selection made — highlight the options area */
              var opts = currentStep.querySelector('.wizard__options');
              if (opts) {
                opts.classList.add('wizard__options--shake');
                setTimeout(function() { opts.classList.remove('wizard__options--shake'); }, 600);
              }
              /* Show inline message */
              var msg = currentStep.querySelector('.wizard__require-msg');
              if (!msg) {
                msg = document.createElement('div');
                msg.className = 'wizard__require-msg';
                msg.textContent = 'Please select an option to continue';
                var nudge = currentStep.querySelector('.wizard__nudge');
                if (nudge) nudge.after(msg);
                else if (opts) opts.parentNode.insertBefore(msg, opts);
              }
              msg.style.display = '';
              return;
            }
          }
          if (self.step < self.total) {
            self.goTo(self.step + 1);
          } else {
            /* Last step → mark completed, then scroll to measurements */
            self._completeAll();
            var ms = document.getElementById('measurements-section');
            if (ms) {
              ms.scrollIntoView({ behavior: 'smooth', block: 'start' });
              ms.classList.add('product-measurements--highlight');
              setTimeout(function() { ms.classList.remove('product-measurements--highlight'); }, 1500);
            }
          }
        });
      });

      /* Nav: back */
      wiz.querySelectorAll('[data-wizard-prev]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          if (self.step > 1) self.goTo(self.step - 1);
        });
      });

      /* Header clicks (accordion) */
      wiz.querySelectorAll('[data-wizard-step-toggle]').forEach(function(hdr) {
        hdr.addEventListener('click', function() {
          var n = parseInt(hdr.dataset.wizardStepToggle, 10);
          var el = wiz.querySelector('[data-wizard-step="' + n + '"]');
          if (el && (el.classList.contains('is-completed') || el.classList.contains('is-active'))) {
            self.goTo(n);
          }
        });
      });

      /* Help toggles */
      wiz.querySelectorAll('[data-toggle-help]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          var stepHelp = btn.closest('[data-step-help]');
          var panel = stepHelp && stepHelp.querySelector('[data-help-panel]');
          if (panel) panel.classList.toggle('is-open');
        });
      });

      /* ── Remove all default selections — customer must explicitly choose ── */
      wiz.querySelectorAll('.wizard__option.is-selected').forEach(function(opt) {
        opt.classList.remove('is-selected');
      });
      /* selections starts empty — only populated when customer clicks */

      /* ── Tap-to-zoom on option images ── */
      this._initZoom(wiz);

      /* ── Mini carousels inside option cards ── */
      this._initCarousels(wiz);

      /* ── Create banner for initial active step ── */
      var activeStep = wiz.querySelector('.wizard__step.is-active');
      if (activeStep) {
        this._ensureBanner(activeStep, this.step);
      }

      /* ── Populate step-footer counters ── */
      this._updateStepCounters(wiz);
    },

    goTo: function(n) {
      var wiz = document.querySelector('[data-wizard]');
      if (!wiz) return;
      this.step = n;
      var self = this;

      wiz.querySelectorAll('[data-wizard-step]').forEach(function(step) {
        var sn = parseInt(step.dataset.wizardStep, 10);
        var body = step.querySelector('[data-wizard-step-body]');
        step.classList.remove('is-active', 'is-completed', 'is-locked');

        if (sn < n) {
          step.classList.add('is-completed');
          if (body) body.classList.add('is-hidden');
          var sel = step.querySelector('[data-step-selection]');
          if (sel && self.selections[step.dataset.stepProperty]) {
            sel.textContent = self.selections[step.dataset.stepProperty].value;
          }
        } else if (sn === n) {
          step.classList.add('is-active');
          if (body) body.classList.remove('is-hidden');
          self._ensureBanner(step, sn);
        } else {
          if (body) body.classList.add('is-hidden');
        }
      });

      this._updateProgress();

      /* Scroll active step into view */
      var activeStep = wiz.querySelector('.wizard__step.is-active');
      if (activeStep) {
        setTimeout(function() {
          activeStep.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 50);
      }

      this._updateStepCounters(wiz);
    },

    /** Mark all steps as completed (used when finishing the last step) */
    _completeAll: function() {
      var wiz = document.querySelector('[data-wizard]');
      if (!wiz) return;
      var self = this;
      wiz.querySelectorAll('[data-wizard-step]').forEach(function(step) {
        step.classList.remove('is-active');
        step.classList.add('is-completed');
        var body = step.querySelector('[data-wizard-step-body]');
        if (body) body.classList.add('is-hidden');
        var sel = step.querySelector('[data-step-selection]');
        if (sel && self.selections[step.dataset.stepProperty]) {
          sel.textContent = self.selections[step.dataset.stepProperty].value;
        }
      });
      /* Update all progress bars to done */
      document.querySelectorAll('[data-progress-step]').forEach(function(bar) {
        bar.classList.remove('is-active');
        bar.classList.add('is-done');
      });
      var label = document.querySelector('[data-wizard-progress-label]');
      if (label) label.textContent = 'All steps complete ✓';
      /* Show completion in collapsed fork label */
      var lbl = document.querySelector('[data-fork-step-label]');
      if (lbl) lbl.textContent = ' · Complete ✓';
    },

    /** Populate "N of T" counters inside each step-footer */
    _updateStepCounters: function(wiz) {
      if (!wiz) wiz = document.querySelector('[data-wizard]');
      if (!wiz) return;
      var total = this.total;
      wiz.querySelectorAll('[data-step-counter]').forEach(function(el) {
        var step = el.closest('[data-wizard-step]');
        if (step) {
          var n = parseInt(step.dataset.wizardStep, 10);
          el.textContent = n + ' of ' + total;
        }
      });
    },

    /** Create or update the C-style banner inside the active step */
    _ensureBanner: function(stepEl, stepNum) {
      var banner = stepEl.querySelector('.wizard__step-banner');
      if (!banner) {
        banner = document.createElement('div');
        banner.className = 'wizard__step-banner';
        var header = stepEl.querySelector('.wizard__step-header');
        if (header) header.after(banner);
      }

      var titleEl = stepEl.querySelector('.wizard__step-title');
      var title = titleEl ? titleEl.textContent : '';
      var desc = this.stepDescs[title] || '';

      var dotsHtml = '';
      for (var i = 1; i <= this.total; i++) {
        var cls = 'wizard__step-banner__dot';
        if (i < stepNum) cls += ' is-done';
        else if (i === stepNum) cls += ' is-current';
        dotsHtml += '<div class="' + cls + '"></div>';
      }

      banner.innerHTML =
        '<div class="wizard__step-banner__row">' +
          '<span class="wizard__step-banner__num">' + stepNum + '</span>' +
          '<span class="wizard__step-banner__title">' + title + '</span>' +
        '</div>' +
        (desc ? '<div class="wizard__step-banner__desc">' + desc + '</div>' : '') +
        '<div class="wizard__step-banner__progress">' + dotsHtml + '</div>';
    },

    _updateProgress: function() {
      var self = this;
      document.querySelectorAll('[data-progress-step]').forEach(function(bar) {
        var sn = parseInt(bar.dataset.progressStep, 10);
        bar.classList.toggle('is-done', sn < self.step);
        bar.classList.toggle('is-active', sn === self.step);
      });
      var label = document.querySelector('[data-wizard-progress-label]');
      if (label) {
        var el = document.querySelector('[data-wizard-step="' + this.step + '"]');
        var t = el ? el.querySelector('.wizard__step-title') : null;
        label.textContent = 'Step ' + this.step + ' of ' + this.total + (t ? ' — ' + t.textContent : '');
      }

      /* Update collapsed fork label */
      Luxire.Fork.updateStepLabel(this.step, this.total);
    },

    /** ── Select an option (shared by click + zoom handlers) ── */
    _selectOption: function(optBtn) {
      var optGroup = optBtn.closest('[data-options]');
      if (!optGroup) optGroup = optBtn.closest('.wizard__options');
      if (optGroup) optGroup.querySelectorAll('[data-option]').forEach(function(o) {
        o.classList.remove('is-selected');
      });
      optBtn.classList.add('is-selected');
      var step = optBtn.closest('[data-wizard-step]');
      if (step) {
        this.selections[step.dataset.stepProperty] = {
          value: optBtn.dataset.value,
          surcharge: parseInt(optBtn.dataset.surcharge || '0', 10)
        };
        this.userTouched[step.dataset.stepProperty] = true;
        /* Hide validation message if shown */
        var reqMsg = step.querySelector('.wizard__require-msg');
        if (reqMsg) reqMsg.style.display = 'none';
        /* Show selected option description */
        var desc = optBtn.dataset.optionDesc;
        var descEl = step.querySelector('.wizard__selected-desc');
        if (!descEl) {
          descEl = document.createElement('div');
          descEl.className = 'wizard__selected-desc';
          var grid = step.querySelector('.wizard__options');
          if (grid) grid.parentNode.insertBefore(descEl, grid.nextSibling);
        }
        descEl.textContent = desc || '';
        descEl.style.display = desc ? '' : 'none';
      }
      Luxire.Pricing.calculate();
    },

    /** ── Zoom via magnifier icon (supports multi-image carousel) ── */
    _initZoom: function(wiz) {
      var self = this;
      /* Create shared overlay with carousel support */
      var overlay = document.createElement('div');
      overlay.className = 'wizard__zoom-overlay';
      overlay.innerHTML =
        '<div class="wizard__zoom-card">' +
          '<div class="wizard__zoom-carousel">' +
            '<img class="wizard__zoom-card__img" src="" alt="">' +
          '</div>' +
          '<div class="wizard__zoom-dots"></div>' +
          '<div class="wizard__zoom-card__title"></div>' +
          '<div class="wizard__zoom-card__desc"></div>' +
          '<div class="wizard__zoom-card__surcharge"></div>' +
          '<button class="wizard__zoom-card__close" type="button">Close</button>' +
        '</div>';
      document.body.appendChild(overlay);

      var card = overlay.querySelector('.wizard__zoom-card');
      var carouselWrap = overlay.querySelector('.wizard__zoom-carousel');
      var dotsWrap = overlay.querySelector('.wizard__zoom-dots');
      var titleEl = overlay.querySelector('.wizard__zoom-card__title');
      var descEl = overlay.querySelector('.wizard__zoom-card__desc');
      var surEl = overlay.querySelector('.wizard__zoom-card__surcharge');

      function closeZoom() {
        overlay.classList.remove('is-open');
        document.body.classList.remove('is-scroll-locked');
      }
      overlay.addEventListener('click', closeZoom);
      card.addEventListener('click', function(e) { e.stopPropagation(); });
      overlay.querySelector('.wizard__zoom-card__close').addEventListener('click', closeZoom);

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeZoom();
      });

      function showZoom(optBtn) {
        /* Gather images: data-option-imgs (pipe-delimited) or single img */
        var imgUrls = [];
        if (optBtn.dataset.optionImgs) {
          imgUrls = optBtn.dataset.optionImgs.split('|');
        } else {
          var singleImg = optBtn.querySelector('[data-option-img] img');
          if (singleImg) imgUrls = [singleImg.src];
        }
        if (!imgUrls.length) return;

        /* Build zoom carousel */
        carouselWrap.innerHTML = '';
        dotsWrap.innerHTML = '';
        imgUrls.forEach(function(url, i) {
          var img = document.createElement('img');
          img.className = 'wizard__zoom-slide' + (i === 0 ? ' is-active' : '');
          img.src = url.replace(/width=\d+/, 'width=500') + (url.indexOf('width=') < 0 ? '&width=500' : '');
          img.alt = (optBtn.dataset.value || '') + ' view ' + (i + 1);
          img.dataset.idx = i;
          carouselWrap.appendChild(img);

          if (imgUrls.length > 1) {
            var dot = document.createElement('span');
            dot.className = 'wizard__zoom-dot' + (i === 0 ? ' is-active' : '');
            dot.dataset.idx = i;
            dot.addEventListener('click', function(e) {
              e.stopPropagation();
              carouselWrap.querySelectorAll('.wizard__zoom-slide').forEach(function(s) { s.classList.remove('is-active'); });
              dotsWrap.querySelectorAll('.wizard__zoom-dot').forEach(function(d) { d.classList.remove('is-active'); });
              carouselWrap.querySelector('[data-idx="' + dot.dataset.idx + '"]').classList.add('is-active');
              dot.classList.add('is-active');
            });
            dotsWrap.appendChild(dot);
          }
        });

        titleEl.textContent = optBtn.dataset.value || '';
        descEl.textContent = optBtn.dataset.optionDesc || '';
        descEl.style.display = optBtn.dataset.optionDesc ? '' : 'none';
        var sur = parseInt(optBtn.dataset.surcharge || '0', 10);
        surEl.textContent = sur > 0 ? '+' + (Luxire.Pricing.currencyPrefix || '$') + sur.toFixed(2) : '';
        surEl.classList.toggle('is-hidden', sur <= 0);

        overlay.classList.add('is-open');
        document.body.classList.add('is-scroll-locked');
      }

      /* Add magnifier icon to each option that has an image */
      wiz.querySelectorAll('[data-option]').forEach(function(optBtn) {
        var imgWrap = optBtn.querySelector('[data-option-img]');
        if (!imgWrap) return;
        var hasImg = imgWrap.querySelector('img');
        if (!hasImg) return;

        var mag = document.createElement('button');
        mag.type = 'button';
        mag.className = 'wizard__option-zoom';
        mag.setAttribute('aria-label', 'Zoom ' + (optBtn.dataset.value || ''));
        mag.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="10" r="7"/><line x1="15" y1="15" x2="21" y2="21"/></svg>';
        optBtn.appendChild(mag);

        mag.addEventListener('click', function(e) {
          e.stopPropagation();
          showZoom(optBtn);
        });
      });
    },

    /** ── Mini carousels inside option cards ── */
    _initCarousels: function(wiz) {
      wiz.querySelectorAll('[data-carousel]').forEach(function(carousel) {
        var slides = carousel.querySelectorAll('.wizard__carousel-slide');
        if (slides.length < 2) return;
        var wrap = carousel.parentNode;
        var dotsWrap = wrap.querySelector('.wizard__carousel-dots');
        var dots = dotsWrap ? dotsWrap.querySelectorAll('.wizard__carousel-dot') : [];

        function goTo(idx) {
          slides.forEach(function(s) { s.classList.remove('is-active'); });
          dots.forEach(function(d) { d.classList.remove('is-active'); });
          slides[idx].classList.add('is-active');
          if (dots[idx]) dots[idx].classList.add('is-active');
        }

        function currentIdx() {
          var c = carousel.querySelector('.wizard__carousel-slide.is-active');
          return c ? parseInt(c.dataset.slide, 10) : 0;
        }

        /* Dot clicks */
        dots.forEach(function(dot) {
          dot.addEventListener('click', function(e) {
            e.stopPropagation();
            goTo(parseInt(dot.dataset.dot, 10));
          });
        });

        /* Arrow clicks */
        var prevBtn = wrap.querySelector('[data-carousel-prev]');
        var nextBtn = wrap.querySelector('[data-carousel-next]');
        if (prevBtn) prevBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          var i = currentIdx();
          goTo(i > 0 ? i - 1 : slides.length - 1);
        });
        if (nextBtn) nextBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          var i = currentIdx();
          goTo(i < slides.length - 1 ? i + 1 : 0);
        });

        /* Swipe support for touch */
        var startX = 0;
        carousel.addEventListener('touchstart', function(e) {
          startX = e.touches[0].clientX;
        }, { passive: true });
        carousel.addEventListener('touchend', function(e) {
          var diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) < 30) return;
          var i = currentIdx();
          if (diff > 0) goTo(i < slides.length - 1 ? i + 1 : 0);
          else goTo(i > 0 ? i - 1 : slides.length - 1);
        }, { passive: true });
      });
    }
  };


  /* ═══════════════════════
     MEASUREMENTS
     Panels toggled via .is-active class on both block and panel.
     ═══════════════════════ */

  Luxire.Measurements = {
    currentMethod: '',

    init: function() {
      var root = document.querySelector('[data-measurements]');
      if (!root) return;
      var self = this;

      /* Method button clicks */
      root.querySelectorAll('[data-method]').forEach(function(btn) {
        btn.addEventListener('click', function() { self.setMethod(btn.dataset.method); });
      });

      /* Help buttons on measurement fields → open drawer */
      root.querySelectorAll('.measurement-panel__help').forEach(function(btn) {
        btn.addEventListener('click', function() {
          self.openHelpDrawer(btn.dataset.helpField);
        });
      });

      /* Close help drawer */
      document.querySelectorAll('[data-close-help-drawer]').forEach(function(el) {
        el.addEventListener('click', function() { self.closeHelpDrawer(); });
      });

      /* Escape key closes help drawer */
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && document.querySelector('.measurement-help-drawer.is-open')) {
          self.closeHelpDrawer();
        }
      });

      /* Auto-fill from saved measurement profile */
      self.autoFillFromProfile();

      /* ── EZS Help Modals (? buttons → modal with image + steps) ── */
      var ezsHelpMap = {
        'pant-waist': 'body-waist',
        'pant-inseam': 'body-inseam',
        'shirt-neck': 'body-neck',
        'shirt-sleeve': 'body-sleeve'
      };

      document.querySelectorAll('[data-ezs-help]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          var key = ezsHelpMap[btn.dataset.ezsHelp];
          var data = window.LuxireMeasurementHelp && window.LuxireMeasurementHelp[key];
          if (!data) return;
          var modal = document.querySelector('[data-ezs-modal="help"]');
          if (!modal) return;
          var title = modal.querySelector('[data-ezs-modal-title]');
          var body = modal.querySelector('[data-ezs-modal-body]');
          if (title) title.textContent = data.title || '';
          if (body) {
            var html = '';
            if (data.image) html += '<img class="ezs-modal__img" src="' + data.image + '" alt="' + (data.title || '') + '" loading="lazy">';
            if (data.instruction) html += '<p class="ezs-modal__instruction">' + data.instruction + '</p>';
            if (data.steps && data.steps.length) {
              html += '<ol class="ezs-modal__steps">';
              data.steps.forEach(function(s) { html += '<li>' + s + '</li>'; });
              html += '</ol>';
            }
            if (data.tip) html += '<p class="ezs-modal__tip"><strong>Tip:</strong> ' + data.tip + '</p>';
            body.innerHTML = html;
          }
          modal.style.display = 'flex';
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        });
      });

      /* ── EZS Chart Modal ── */
      document.querySelectorAll('[data-ezs-chart]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          var chartType = btn.dataset.ezsChart;
          var modal = document.querySelector('[data-ezs-modal="chart"]');
          if (!modal) return;
          /* Show the correct chart content */
          modal.querySelectorAll('[data-ezs-chart-content]').forEach(function(c) {
            c.style.display = c.dataset.ezsChartContent === chartType ? '' : 'none';
          });
          modal.style.display = 'flex';
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          /* Trigger chart population if needed */
          self._initInlineCharts();
        });
      });

      /* ── EZS Modal Close handlers ── */
      document.querySelectorAll('[data-ezs-modal-close]').forEach(function(el) {
        el.addEventListener('click', function() {
          var modal = el.closest('[data-ezs-modal]');
          if (modal) {
            modal.style.display = 'none';
            modal.classList.remove('is-open');
            document.body.style.overflow = '';
          }
        });
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          document.querySelectorAll('[data-ezs-modal].is-open').forEach(function(m) {
            m.style.display = 'none';
            m.classList.remove('is-open');
          });
          document.body.style.overflow = '';
        }
      });

      /* ── Legacy Help Tip toggles (for non-EZS pages) ── */
      document.querySelectorAll('[data-meas-tip]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          var tipId = btn.dataset.measTip;
          var body = document.querySelector('[data-meas-tip-body="' + tipId + '"]');
          if (!body) return;
          var isOpen = body.classList.contains('is-visible');
          /* Close all tips first */
          document.querySelectorAll('.meas-help-tip__body.is-visible').forEach(function(b) { b.classList.remove('is-visible'); });
          document.querySelectorAll('.meas-help-tip.is-open').forEach(function(b) { b.classList.remove('is-open'); });
          if (!isOpen) {
            body.classList.add('is-visible');
            btn.classList.add('is-open');
          }
        });
      });

      /* ── Inline Size Charts (populated from fit-bible-data.js) ── */
      self._initInlineCharts();
      self._initInlineChartPills();

      /* ── Standard Size Chip Grid (suit/jacket) ── */
      /* Region toggle: US / EU */
      root.querySelectorAll('[data-region-btn]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var region = btn.dataset.regionBtn;
          root.querySelectorAll('[data-region-btn]').forEach(function(b) {
            b.classList.toggle('is-active', b.dataset.regionBtn === region);
          });
          root.querySelectorAll('[data-region-panel]').forEach(function(p) {
            p.classList.toggle('is-hidden', p.dataset.regionPanel !== region);
          });
          /* Clear all chip selections when switching regions */
          root.querySelectorAll('.std-chip').forEach(function(c) {
            c.classList.remove('is-selected');
          });
          var hiddenJacket = root.querySelector('[data-std-jacket-size]');
          if (hiddenJacket) hiddenJacket.value = '';
          var hiddenWaist = root.querySelector('[data-std-trouser-waist]');
          if (hiddenWaist) hiddenWaist.value = '';
          var hiddenInseam = root.querySelector('[data-std-trouser-inseam]');
          if (hiddenInseam) hiddenInseam.value = '';
        });
      });

      /* Chip click: select one per group, update hidden input */
      root.querySelectorAll('.std-chip').forEach(function(chip) {
        chip.addEventListener('click', function() {
          /* Get group name — attribute may be on button itself (MTM) or parent grid (EZS) */
          var gridEl = chip.closest('[data-chip-group]');
          var group = gridEl ? gridEl.dataset.chipGroup : '';
          var value = chip.dataset.chipValue;

          /* Deselect all chips in same group within visible region */
          var region = chip.closest('[data-region-panel]') || chip.closest('.measurement-panel') || root;
          region.querySelectorAll('.std-chip').forEach(function(c) {
            var cGrid = c.closest('[data-chip-group]');
            if (cGrid && cGrid.dataset.chipGroup === group) {
              c.classList.remove('is-selected');
            }
          });
          chip.classList.add('is-selected');

          /* Update corresponding hidden input */
          var inputMap = {
            'jacket-size': '[data-std-jacket-size]',
            'trouser-waist': '[data-std-trouser-waist]',
            'trouser-inseam': '[data-std-trouser-inseam]'
          };
          var input = root.querySelector(inputMap[group]);
          if (input) input.value = value;

          Luxire.Pricing.updateProperties();
        });
      });

      /* ── Shirt Standard Size Toggle: Quick vs Exact ── */
      root.querySelectorAll('[data-shirt-size-mode]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var mode = btn.dataset.shirtSizeMode;
          /* Toggle button active state */
          root.querySelectorAll('[data-shirt-size-mode]').forEach(function(b) {
            b.classList.toggle('is-active', b.dataset.shirtSizeMode === mode);
          });
          /* Toggle panels */
          root.querySelectorAll('[data-shirt-size-panel]').forEach(function(p) {
            var isActive = p.dataset.shirtSizePanel === mode;
            p.classList.toggle('is-hidden', !isActive);
            /* Disable inputs in hidden panel so they don't get collected */
            p.querySelectorAll('input, select').forEach(function(inp) {
              inp.disabled = !isActive;
            });
          });
          Luxire.Pricing.updateProperties();
        });
      });
      /* On init: disable exact panel inputs */
      root.querySelectorAll('[data-shirt-size-panel="exact"] input, [data-shirt-size-panel="exact"] select').forEach(function(inp) {
        inp.disabled = true;
      });
    },

    autoFillFromProfile: function() {
      var profile = {};
      // Use LuxireStorage for measurement profiles
      if (typeof LuxireStorage !== 'undefined') {
        var profiles = LuxireStorage.getMeasurementProfilesSync();
        var defaultProfile = profiles.find(function(p) { return p.isDefault; }) || profiles[0];
        if (defaultProfile && defaultProfile.measurements) {
          profile = defaultProfile.measurements;
        }
      }
      if (Object.keys(profile).length === 0) return;

      var filled = 0;
      document.querySelectorAll('.measurement-panel__input').forEach(function(input) {
        var name = input.name;
        if (!name) return;
        /* name is like "properties[Pant Waist]" — extract the key */
        var match = name.match(/properties\[(.+)\]/);
        if (!match) return;
        var key = match[1];
        if (profile[key] && !input.value) {
          input.value = profile[key];
          filled++;
        }
      });

      if (filled > 0) {
        /* Show a subtle note in the garment/body panels */
        var panels = document.querySelectorAll('.measurement-panel[data-measurement-panel="garment"], .measurement-panel[data-measurement-panel="body"]');
        panels.forEach(function(panel) {
          var note = panel.querySelector('.measurement-panel__note');
          if (note && !panel.querySelector('.mp-autofill-note')) {
            var hint = document.createElement('p');
            hint.className = 'mp-autofill-note';
            hint.style.cssText = 'font-size:0.8rem;color:var(--color-accent);margin-top:8px;';
            hint.textContent = '✓ Pre-filled from your saved profile. You can adjust any values.';
            note.parentNode.insertBefore(hint, note.nextSibling);
          }
        });
      }
    },

    /** ── Inline Size Charts: populate from fbSizeData ── */
    _initInlineCharts: function() {
      if (!window.fbSizeData) return;
      this._renderPantChart('dress_pant');
      this._renderShirtChart('slim', 'quick');
    },

    _renderPantChart: function(pantType) {
      var table = document.getElementById('ezs-pant-chart-table');
      if (!table || !window.fbSizeData || !window.fbSizeData.pants) return;
      var data = window.fbSizeData.pants[pantType];
      if (!data) return;
      var tbody = table.querySelector('tbody');
      tbody.innerHTML = '';
      data.forEach(function(row) {
        var tr = document.createElement('tr');
        tr.dataset.chartSize = String(row.size);
        tr.innerHTML = '<td><strong>' + row.size + '</strong></td><td>' + row.waist + '</td><td>' + row.hip + '</td><td>' + row.fr + '</td><td>' + row.br + '</td><td>' + row.thigh + '</td><td>' + row.knee + '</td><td>' + row.bottom + '</td>';
        tbody.appendChild(tr);
      });
    },

    _renderShirtChart: function(fit, mode) {
      var table = document.getElementById('ezs-shirt-chart-table');
      if (!table || !window.fbSizeData || !window.fbSizeData.shirts) return;

      /* Determine which dataset: quick → size-based, exact → collar-based */
      var isQuick = (mode === 'quick');
      var key = fit === 'regular'
        ? (isQuick ? 'regular_fit_size' : 'regular_fit_collar')
        : (isQuick ? 'slim_fit_size' : 'slim_fit_collar');
      var data = window.fbSizeData.shirts[key];
      if (!data) return;

      var thead = table.querySelector('thead');
      var tbody = table.querySelector('tbody');

      if (isQuick) {
        thead.innerHTML = '<tr><th>Size</th><th>Neck</th><th>Chest</th><th>Waist</th><th>Bottom</th><th>Yoke</th><th>Biceps</th><th>Cuff</th><th>Length</th></tr>';
        tbody.innerHTML = '';
        data.forEach(function(row) {
          var tr = document.createElement('tr');
          tr.dataset.chartSize = row.size;
          tr.innerHTML = '<td><strong>' + row.size + '</strong></td><td>' + row.neck + '</td><td>' + row.chest + '</td><td>' + row.waist + '</td><td>' + row.bottom + '</td><td>' + row.yoke + '</td><td>' + row.biceps + '</td><td>' + row.cuff + '</td><td>' + row.length + '</td>';
          tbody.appendChild(tr);
        });
      } else {
        thead.innerHTML = '<tr><th>Collar</th><th>Chest</th><th>Waist</th><th>Bottom</th><th>Yoke</th><th>Biceps</th><th>Cuff</th><th>Length</th></tr>';
        tbody.innerHTML = '';
        data.forEach(function(row) {
          var tr = document.createElement('tr');
          tr.dataset.chartSize = String(row.collar);
          tr.innerHTML = '<td><strong>' + row.collar + '</strong></td><td>' + row.chest + '</td><td>' + row.waist + '</td><td>' + row.bottom + '</td><td>' + row.yoke + '</td><td>' + row.biceps + '</td><td>' + row.cuff + '</td><td>' + row.length + '</td>';
          tbody.appendChild(tr);
        });
      }
    },

    _initInlineChartPills: function() {
      var self = this;

      /* Pant type pills */
      document.querySelectorAll('[data-chart-pills="pant-type"] .meas-chart-inline__pill').forEach(function(pill) {
        pill.addEventListener('click', function() {
          pill.closest('.meas-chart-inline__pills').querySelectorAll('.meas-chart-inline__pill').forEach(function(p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          self._renderPantChart(pill.dataset.value);
          self._highlightPantRow();
        });
      });

      /* Shirt fit pills */
      document.querySelectorAll('[data-chart-pills="shirt-fit"] .meas-chart-inline__pill').forEach(function(pill) {
        pill.addEventListener('click', function() {
          pill.closest('.meas-chart-inline__pills').querySelectorAll('.meas-chart-inline__pill').forEach(function(p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          var mode = document.querySelector('[data-shirt-size-panel="exact"]:not(.is-hidden)') ? 'exact' : 'quick';
          self._renderShirtChart(pill.dataset.value, mode);
          self._highlightShirtRow();
        });
      });

      /* Re-render shirt chart when tab switches between quick/exact */
      document.querySelectorAll('[data-shirt-size-mode]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          setTimeout(function() {
            var fitPill = document.querySelector('[data-chart-pills="shirt-fit"] .meas-chart-inline__pill.is-active');
            var fit = fitPill ? fitPill.dataset.value : 'slim';
            var mode = btn.dataset.shirtSizeMode;
            self._renderShirtChart(fit, mode);
          }, 50);
        });
      });

      /* Highlight row when size/neck changes */
      var sizeSelect = document.getElementById('m-std-size-ezs');
      if (sizeSelect) sizeSelect.addEventListener('change', function() { self._highlightShirtRow(); });
      var neckSelect = document.getElementById('m-std-neck-ezs');
      if (neckSelect) neckSelect.addEventListener('change', function() { self._highlightShirtRow(); });
      var pantSelect = document.querySelector('[name="properties[Standard Size]"]');
      if (pantSelect) pantSelect.addEventListener('change', function() { self._highlightPantRow(); });
    },

    _highlightShirtRow: function() {
      var table = document.getElementById('ezs-shirt-chart-table');
      if (!table) return;
      table.querySelectorAll('tr.is-highlighted').forEach(function(r) { r.classList.remove('is-highlighted'); });
      /* Try quick size first */
      var sel = document.getElementById('m-std-size-ezs');
      if (sel && sel.value) {
        var row = table.querySelector('tr[data-chart-size="' + sel.value + '"]');
        if (row) row.classList.add('is-highlighted');
        return;
      }
      /* Try exact neck */
      var neck = document.getElementById('m-std-neck-ezs');
      if (neck && neck.value) {
        var nv = neck.value.replace('"', '');
        var row = table.querySelector('tr[data-chart-size="' + nv + '"]');
        if (row) row.classList.add('is-highlighted');
      }
    },

    _highlightPantRow: function() {
      var table = document.getElementById('ezs-pant-chart-table');
      if (!table) return;
      table.querySelectorAll('tr.is-highlighted').forEach(function(r) { r.classList.remove('is-highlighted'); });
      var sel = document.querySelector('[name="properties[Standard Size]"]');
      if (sel && sel.value) {
        var row = table.querySelector('tr[data-chart-size="' + sel.value + '"]');
        if (row) row.classList.add('is-highlighted');
      }
    },

    setMethod: function(method) {
      this.currentMethod = method;

      /* Hide validation message if shown */
      var reqMsg = document.querySelector('#measurements-section .wizard__require-msg');
      if (reqMsg) reqMsg.style.display = 'none';

      /* Toggle .is-active on buttons */
      document.querySelectorAll('[data-method]').forEach(function(btn) {
        btn.classList.toggle('is-active', btn.dataset.method === method);
      });

      /* Toggle .is-active on parent blocks */
      document.querySelectorAll('.measurement-method-block').forEach(function(block) {
        var btn = block.querySelector('[data-method]');
        block.classList.toggle('is-active', btn && btn.dataset.method === method);
      });

      /* Toggle .is-active on panels — CSS handles display */
      document.querySelectorAll('[data-measurement-panel]').forEach(function(panel) {
        panel.classList.toggle('is-active', panel.dataset.measurementPanel === method);
      });

      Luxire.Pricing.updateProperties();
    },

    openHelpDrawer: function(field) {
      var drawer = document.querySelector('[data-measurement-help-drawer]');
      if (!drawer || !field) return;
      var title = drawer.querySelector('[data-help-drawer-title]');
      var body  = drawer.querySelector('[data-help-drawer-body]');

      var data = window.LuxireMeasurementHelp && window.LuxireMeasurementHelp[field];
      if (title) title.textContent = data ? data.title : ('How to Measure: ' + field.replace(/-/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); }));

      if (body) {
        if (data) {
          var html = '';
          if (data.image) html += '<img src="' + data.image + '" alt="' + (data.title || '') + '" loading="lazy">';
          if (data.instruction) html += '<p class="measurement-help-drawer__instruction">' + data.instruction + '</p>';
          if (data.steps && data.steps.length) {
            html += '<ol class="measurement-help-drawer__steps">';
            data.steps.forEach(function(s) { html += '<li>' + s + '</li>'; });
            html += '</ol>';
          }
          if (data.tip) html += '<p class="measurement-help-drawer__tip"><strong>Tip:</strong> ' + data.tip + '</p>';
          body.innerHTML = html;
        } else {
          var fieldName = field.replace(/-/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
          body.innerHTML = '<p>Lay your garment flat and measure the ' + fieldName.toLowerCase() + '. Keep the tape straight and snug but not tight.</p>';
        }
      }

      drawer.classList.add('is-open');
      document.body.classList.add('is-scroll-locked');
    },

    closeHelpDrawer: function() {
      var drawer = document.querySelector('[data-measurement-help-drawer]');
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('is-scroll-locked');
    }
  };


  /* ═══════════════════════
     MONOGRAM
     ═══════════════════════ */

  Luxire.Monogram = {
    init: function() {
      var toggle = document.querySelector('[data-monogram-toggle]');
      var fields = document.querySelector('[data-monogram-fields]');
      if (!toggle || !fields) return;

      toggle.addEventListener('change', function() {
        fields.classList.toggle('is-open', toggle.checked);
        Luxire.Pricing.calculate();
      });

      var colors = document.querySelectorAll('[data-monogram-colors] [data-color]');
      var colorField = document.querySelector('[data-monogram-color-field]');
      colors.forEach(function(btn) {
        btn.addEventListener('click', function() {
          colors.forEach(function(c) { c.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          if (colorField) colorField.value = btn.dataset.color;
        });
      });
    }
  };


  /* ═══════════════════════
     SPECIAL INSTRUCTIONS
     ═══════════════════════ */

  Luxire.Instructions = {
    init: function() {
      var chips = [].slice.call(document.querySelectorAll('[data-chip]'));
      var ta = document.querySelector('[data-instructions-textarea]');
      if (!ta || !chips.length) return;

      chips.forEach(function(chip) {
        chip.addEventListener('click', function() {
          chip.classList.toggle('is-active');
          /* Rebuild textarea: active chips + manual text */
          var active = [].slice.call(document.querySelectorAll('[data-chip].is-active'));
          var texts = active.map(function(c) { return c.dataset.chip; });
          var manual = ta.value;
          chips.forEach(function(c) {
            manual = manual.replace(c.dataset.chip + '. ', '').replace(c.dataset.chip, '');
          });
          manual = manual.replace(/\s{2,}/g, ' ').trim();
          ta.value = (texts.length ? texts.join('. ') + '. ' : '') + manual;
        });
      });
    }
  };


  /* ═══════════════════════
     TABS — CSS-class based
     ═══════════════════════ */

  Luxire.Tabs = {
    init: function() {
      var root = document.querySelector('[data-tabs]');
      if (!root) return;
      var tabs = root.querySelectorAll('[data-tab]');
      var panels = root.querySelectorAll('[data-tab-panel]');

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var target = tab.dataset.tab;
          tabs.forEach(function(t) {
            t.classList.toggle('is-active', t.dataset.tab === target);
            t.setAttribute('aria-selected', t.dataset.tab === target);
          });
          panels.forEach(function(p) {
            p.classList.toggle('is-active', p.dataset.tabPanel === target);
          });
        });
      });
    }
  };


  /* ═══════════════════════
     FLOATING BAR
     ═══════════════════════ */

  Luxire.FloatingBar = {
    init: function() {
      var bar = document.querySelector('[data-floating-bar]');
      var cartBtn = document.querySelector('.product-cart-section__btn');
      if (!bar || !cartBtn) return;

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
          bar.setAttribute('aria-hidden', entry.isIntersecting);
        });
      }, { threshold: 0 });
      observer.observe(cartBtn);

      var floatAtc = bar.querySelector('[data-floating-bar-atc]');
      if (floatAtc) {
        floatAtc.addEventListener('click', function() {
          Luxire.Pricing.updateProperties();
          var form = document.querySelector('[data-product-form]');
          if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }
    }
  };


  /* ═══════════════════════
     PRICING + CART PROPERTIES
     Single source of truth for line item properties.
     ═══════════════════════ */

  /* ═══════════════════════════════════════
     SURCHARGE VARIANT MAP
     Product: "Surcharge" on Luxire Shopify
     ═══════════════════════════════════════ */

  Luxire.SurchargeVariants = {
    1:   47827189498070,
    5:   47827189530838,
    10:  47827189563606,
    15:  47827189596374,
    20:  47827189629142,
    25:  47827189661910,
    30:  47827189694678,
    35:  47827189727446,
    40:  47827189760214,
    45:  47827189792982,
    50:  47827189825750,
    60:  47827189858518,
    75:  47827189891286,
    80:  47827189924054,
    90:  47827189956822,
    100: 47827189989590,

    /** Find the best variant ID for a dollar amount.
     *  Returns { id, price } or null.
     */
    lookup: function(dollars) {
      dollars = Math.round(dollars);
      if (dollars <= 0) return null;
      if (this[dollars]) return { id: this[dollars], price: dollars };
      /* Find closest available that is >= amount (round up) */
      var amounts = [1,5,10,15,20,25,30,35,40,45,50,60,75,80,90,100];
      for (var i = 0; i < amounts.length; i++) {
        if (amounts[i] >= dollars) return { id: this[amounts[i]], price: amounts[i] };
      }
      return { id: this[100], price: 100 }; /* cap at $100 */
    },

    /**
     * Break a dollar amount into exact variant items.
     * E.g. $55 → [$50, $5]; $70 → [$60, $10]
     * Returns array of { id, price }.
     */
    decompose: function(dollars) {
      dollars = Math.round(dollars);
      if (dollars <= 0) return [];
      if (this[dollars]) return [{ id: this[dollars], price: dollars }];
      var amounts = [100,90,80,75,60,50,45,40,35,30,25,20,15,10,5,1];
      var items = [];
      var remaining = dollars;
      for (var i = 0; i < amounts.length && remaining > 0; i++) {
        while (remaining >= amounts[i]) {
          items.push({ id: this[amounts[i]], price: amounts[i] });
          remaining -= amounts[i];
        }
      }
      return items;
    }
  };


  /* ═══════════════════════
     PRICING
     ═══════════════════════ */

  Luxire.Pricing = {
    basePrice: 0,
    currencyPrefix: '$',
    currencySuffix: '',
    useCommaDecimal: false,

    init: function() {
      var el = document.querySelector('[data-base-price]');
      if (el) {
        var raw = el.textContent.trim();
        /* Detect currency symbol — everything before and after digits */
        var prefixMatch = raw.match(/^([^0-9]*)/);
        var suffixMatch = raw.match(/([^0-9.,]*)$/);
        if (prefixMatch && prefixMatch[1]) this.currencyPrefix = prefixMatch[1].trim();
        else this.currencyPrefix = '';
        if (suffixMatch && suffixMatch[1]) this.currencySuffix = suffixMatch[1].trim();
        else this.currencySuffix = '';
        /* Detect European decimal format (comma as decimal) */
        var cleaned = raw.replace(/[^0-9.,]/g, '');
        if (cleaned.indexOf(',') > -1) {
          if (cleaned.indexOf('.') > -1 && cleaned.lastIndexOf('.') < cleaned.lastIndexOf(',')) {
            /* 1.136,95 → European: dot=thousands, comma=decimal */
            this.useCommaDecimal = true;
            cleaned = cleaned.replace(/\./g, '').replace(',', '.');
          } else if (cleaned.indexOf('.') === -1) {
            /* 136,95 → European: comma=decimal */
            this.useCommaDecimal = true;
            cleaned = cleaned.replace(',', '.');
          }
          /* else: 1,136.95 — US format */
        }
        this.basePrice = parseFloat(cleaned) || 0;
      }

      var self = this;
      var form = document.querySelector('[data-product-form]');
      if (!form) return;

      form.addEventListener('submit', function(e) {
        e.preventDefault();

        /* Always sync hidden inputs first */
        try { self.updateProperties(); } catch (err) {
          console.error('[Luxire] updateProperties error on submit:', err);
        }

        /* If CartEdit is active, let it handle the submit */
        if (Luxire.CartEdit && Luxire.CartEdit.editKey) {
          Luxire.CartEdit._doEditSubmit(form);
          return;
        }

        /* Get variant ID */
        var variantInput = form.querySelector('[name="id"]');
        var variantId = variantInput ? parseInt(variantInput.value, 10) : 0;
        if (!variantId) { form.submit(); return; }

        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

        /* ── Build properties from ALL hidden inputs in the form ── */
        var allPropInputs = form.querySelectorAll('input[name^="properties["]');
        var properties = {};
        for (var i = 0; i < allPropInputs.length; i++) {
          var inp = allPropInputs[i];
          var m = inp.name.match(/^properties\[(.+?)\]$/);
          if (m && inp.value) properties[m[1]] = inp.value;
        }

        /* ── Fallback: if no properties found at all, add minimum defaults ── */
        if (Object.keys(properties).length === 0) {
          console.warn('[Luxire] No properties in form! Adding defaults.');
          var productType = document.querySelector('[data-product-type]');
          var typeVal = productType ? productType.dataset.productType : '';
          if (typeVal !== 'ezs') {
            properties['Style'] = 'As Shown';
          }
          properties['Measurement Method'] = 'Standard Size';
        }

        /* ── Build URL-encoded body (same as native form POST) ── */
        var bodyParts = [];
        bodyParts.push('id=' + encodeURIComponent(variantId));
        bodyParts.push('quantity=1');
        for (var key in properties) {
          bodyParts.push('properties[' + encodeURIComponent(key) + ']=' + encodeURIComponent(properties[key]));
        }
        var bodyStr = bodyParts.join('&');
        /* ── STEP 1: Add main product via URL-encoded POST ── */
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
          },
          body: bodyStr
        })
        .then(function(res) {
          if (!res.ok) {
            return res.text().then(function(t) { throw new Error('Cart add failed: ' + res.status + ' ' + t); });
          }
          return res.json();
        })
        .then(function(data) {
          /* ── STEP 2: Add surcharge items (if any) ── */
          var productType = document.querySelector('[data-product-type]');
          var isEZS = productType && productType.dataset.productType === 'ezs';

          if (isEZS) {
            window.location.href = '/cart';
            return;
          }

          var surchargeItems = [];
          try {
            var surPricing = self.calculate();
            var titleEl = document.querySelector('.product-info__title');
            var productName = titleEl ? titleEl.textContent.trim() : 'Custom Garment';
            var productHandle = (titleEl && titleEl.dataset.productHandle) || '';

            surPricing.surchargeItems.forEach(function(sur) {
              /* Never add shipping-type surcharges — these are obsolete */
              if (sur.type === 'shipping') return;

              var variants = Luxire.SurchargeVariants.decompose(sur.amount);
              variants.forEach(function(v) {
                var props = {
                  '_surcharge_for': productName,
                  '_surcharge_for_handle': productHandle,
                  '_surcharge_type': sur.type
                };
                if (sur.type === 'upgrade') props['Upgrade'] = sur.label + ' (+' + (Luxire.Pricing.currencyPrefix || '$') + sur.amount + ')';
                else if (sur.type === 'construction') props['Construction'] = sur.label;
                else if (sur.type === 'service') props['Service'] = sur.label;
                else if (sur.type === 'monogram') props['Monogram'] = 'Personalization';
                surchargeItems.push({ id: v.id, quantity: 1, properties: props });
              });
            });
          } catch (err) { /* no surcharges */ }

          if (surchargeItems.length === 0) {
            window.location.href = '/cart';
            return;
          }

          /* Add surcharges as a batch */
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: surchargeItems })
          })
          .then(function() { window.location.href = '/cart'; })
          .catch(function() { window.location.href = '/cart'; });
        })
        .catch(function(err) {
          console.error('[Luxire] Cart add error:', err);
          /* ── FALLBACK: Native form submit ── */
          if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
          form.submit();
        });
      });
    },

    /** Calculate display total (base + wizard surcharges + Gurkha + send garment + monogram) */
    calculate: function() {
      var total = this.basePrice;
      var surchargeItems = []; /* { label, amount } */

      /* Wizard option surcharges (only user-touched selections) */
      for (var prop in Luxire.Wizard.selections) {
        if (!Luxire.Wizard.userTouched[prop]) continue;
        var s = Luxire.Wizard.selections[prop];
        if (s.surcharge > 0) {
          total += s.surcharge;
          surchargeItems.push({ label: s.value, amount: s.surcharge, type: 'upgrade' });
        }
      }

      /* Gurkha construction surcharge (only for "as shown" track — wizard handles it in customize) */
      var gurkhaEl = document.querySelector('[data-gurkha-fee]');
      var gurkha = gurkhaEl ? parseInt(gurkhaEl.dataset.gurkhaFee || '0', 10) : 0;
      if (gurkha > 0 && Luxire.Fork.currentTrack !== 'customize') {
        total += gurkha;
        surchargeItems.push({ label: 'Gurkha Construction', amount: gurkha, type: 'construction' });
      }

      /* Monogram surcharge */
      var monoToggle = document.querySelector('[data-monogram-toggle]');
      if (monoToggle && monoToggle.checked) {
        var monoFee = parseInt(monoToggle.dataset.monogramFee || '0', 10);
        if (monoFee > 0) {
          total += monoFee;
          surchargeItems.push({ label: 'Monogram', amount: monoFee, type: 'monogram' });
        }
      }

      /* Send Garment service fee — only when "send garment" measurement method is selected */
      if (Luxire.Measurements.currentMethod === 'send') {
        var sendPanel = document.querySelector('[data-send-garment-fee]');
        var sendFee = sendPanel ? parseInt(sendPanel.dataset.sendGarmentFee || '0', 10) : 0;
        if (sendFee > 0) {
          total += sendFee;
          surchargeItems.push({ label: 'Send Garment Service', amount: sendFee, type: 'service' });
        }
      }

      /* Update display — use detected currency format */
      var fmtNum = total.toFixed(2);
      if (this.useCommaDecimal) fmtNum = fmtNum.replace('.', ',');
      var fmt = this.currencyPrefix + fmtNum + (this.currencySuffix ? ' ' + this.currencySuffix : '');
      var totalEl = document.querySelector('[data-total-price]');
      var floatP  = document.querySelector('[data-floating-bar-price]');
      if (totalEl) totalEl.textContent = fmt;
      if (floatP)  floatP.textContent  = fmt;

      return { total: total, surchargeItems: surchargeItems };
    },

    /** Build the hidden properties inputs (unchanged purpose, updated surcharge labels) */
    updateProperties: function() {
      var c = document.querySelector('[data-line-item-properties]');
      if (!c) return;
      var h = '';

      var esc = function(v) { return String(v).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;'); };

      var productType = document.querySelector('[data-product-type]');
      var isEZS = productType && productType.dataset.productType === 'ezs';

      try {
        if (!isEZS) {
          /* Style track */
          var track = Luxire.Fork.currentTrack === 'as-shown' ? 'As Shown' : 'Custom';
          h += '<input type="hidden" name="properties[Style]" value="' + esc(track) + '">';

          /* Measurement method */
          var names = { saved:'Saved Profile', garment:'Garment Measurements', body:'Body Measurements', standard:'Standard Size', send:'Send Garment' };
          var methodName = names[Luxire.Measurements.currentMethod] || '';
          h += '<input type="hidden" name="properties[Measurement Method]" value="' + esc(methodName) + '">';

          /* Wizard selections (only for customize track, only user-touched) */
          if (Luxire.Fork.currentTrack === 'customize') {
            for (var prop in Luxire.Wizard.selections) {
              if (!Luxire.Wizard.userTouched[prop]) continue;
              h += '<input type="hidden" name="properties[' + esc(prop) + ']" value="' + esc(Luxire.Wizard.selections[prop].value) + '">';
            }
          }

          /* Upgrades summary */
          var pricing = this.calculate();
          var upgradeLabels = pricing.surchargeItems.filter(function(s) { return s.type === 'upgrade'; }).map(function(s) { return s.label; });
          if (upgradeLabels.length) {
            h += '<input type="hidden" name="properties[Upgrades]" value="' + esc(upgradeLabels.join(', ')) + '">';
          }
        } else {
          /* EZS: set measurement method to Standard Size if EZS measurement panel exists */
          var ezsPanel = document.querySelector('.product-measurements--ezs');
          if (ezsPanel) {
            h += '<input type="hidden" name="properties[Measurement Method]" value="Standard Size">';
          }
        }
      } catch (err) {
        console.error('[Luxire] updateProperties error in style/method block:', err);
        /* Fallback: ensure at least basic properties exist */
        if (h.indexOf('properties[Style]') === -1) {
          h += '<input type="hidden" name="properties[Style]" value="As Shown">';
        }
        if (h.indexOf('properties[Measurement Method]') === -1) {
          h += '<input type="hidden" name="properties[Measurement Method]" value="Standard Size">';
        }
      }

      /* Measurement values from the active panel */
      try {
        var activePanel = document.querySelector('.measurement-panel.is-active');
        if (activePanel) {
          activePanel.querySelectorAll('input[name^="properties["], select[name^="properties["]').forEach(function(input) {
            if (input.disabled) return;
            if (input.type === 'radio' && !input.checked) return;
            var val = input.value ? input.value.trim() : '';
            if (val) h += '<input type="hidden" name="' + esc(input.name) + '" value="' + esc(val) + '">';
          });
        }

        /* Also collect from EZS measurement panel if present */
        var ezsPanel = document.querySelector('.product-measurements--ezs .measurement-panel');
        if (ezsPanel && ezsPanel !== activePanel) {
          ezsPanel.querySelectorAll('input[name^="properties["], select[name^="properties["]').forEach(function(input) {
            if (input.disabled) return;
            if (input.type === 'radio' && !input.checked) return;
            var val = input.value ? input.value.trim() : '';
            if (val) h += '<input type="hidden" name="' + esc(input.name) + '" value="' + esc(val) + '">';
          });
        }
      } catch (err) {
        console.error('[Luxire] updateProperties error in measurement block:', err);
      }

      /* Monogram */
      var monoToggle = document.querySelector('[data-monogram-toggle]');
      if (monoToggle && monoToggle.checked) {
        var monoRoot = document.querySelector('[data-monogram-fields]');
        if (monoRoot) {
          monoRoot.querySelectorAll('input[name^="properties["], select[name^="properties["]').forEach(function(input) {
            var val = input.value ? input.value.trim() : '';
            if (val) h += '<input type="hidden" name="' + esc(input.name) + '" value="' + esc(val) + '">';
          });
        }
      }

      /* Special Instructions */
      var ta = document.querySelector('[data-instructions-textarea]');
      if (ta && ta.value.trim()) {
        h += '<input type="hidden" name="' + esc(ta.name) + '" value="' + esc(ta.value.trim()) + '">';
      }

      c.innerHTML = h;

      /* Floating bar detail */
      var det = document.querySelector('[data-floating-bar-detail]');
      if (det) {
        var _track = isEZS ? 'EZS' : (Luxire.Fork.currentTrack === 'as-shown' ? 'As Shown' : 'Custom');
        var _method = isEZS ? 'Standard Size' : (typeof methodName === 'string' ? methodName : '');
        det.textContent = _track + (_method ? ' · ' + _method : '');
      }
    },


    /** ══ AJAX Cart Add with Surcharge Line Items ══
     *  Adds the main product PLUS separate surcharge products.
     */
    /** Collect all line-item properties directly from DOM (not from hidden inputs).
     *  Returns a plain object suitable for Shopify cart API. */
    collectProperties: function() {
      var mainProps = {};

      var productType = document.querySelector('[data-product-type]');
      var isEZS = productType && productType.dataset.productType === 'ezs';

      try {
        if (!isEZS) {
          mainProps['Style'] = Luxire.Fork.currentTrack === 'as-shown' ? 'As Shown' : 'Custom';
          var mNames = { saved:'Saved Profile', garment:'Garment Measurements', body:'Body Measurements', standard:'Standard Size', send:'Send Garment' };
          mainProps['Measurement Method'] = mNames[Luxire.Measurements.currentMethod] || 'Standard Size';
          if (Luxire.Fork.currentTrack === 'customize') {
            for (var prop in Luxire.Wizard.selections) {
              if (!Luxire.Wizard.userTouched[prop]) continue;
              mainProps[prop] = Luxire.Wizard.selections[prop].value;
            }
          }
          var pricing = this.calculate();
          var upgradeLabels = pricing.surchargeItems.filter(function(s) { return s.type === 'upgrade'; }).map(function(s) { return s.label; });
          if (upgradeLabels.length) mainProps['Upgrades'] = upgradeLabels.join(', ');
        } else {
          var ezsPanel = document.querySelector('.product-measurements--ezs');
          if (ezsPanel) mainProps['Measurement Method'] = 'Standard Size';
        }
      } catch (err) {
        console.error('[Luxire] collectProperties error (style/method):', err);
        if (!mainProps['Style']) mainProps['Style'] = 'As Shown';
        if (!mainProps['Measurement Method']) mainProps['Measurement Method'] = 'Standard Size';
      }

      /* Measurement values from active panel + EZS panel */
      try {
        var panels = document.querySelectorAll('.measurement-panel.is-active, .product-measurements--ezs .measurement-panel');
        panels.forEach(function(panel) {
          panel.querySelectorAll('input[name^="properties["], select[name^="properties["]').forEach(function(input) {
            if (input.disabled) return;
            if (input.type === 'radio' && !input.checked) return;
            var val = input.value ? input.value.trim() : '';
            if (val) {
              var match = input.name.match(/^properties\[(.+?)\]$/);
              if (match) mainProps[match[1]] = val;
            }
          });
        });
      } catch (err) {
        console.error('[Luxire] collectProperties error (measurements):', err);
      }

      /* Monogram */
      try {
        var monoToggle = document.querySelector('[data-monogram-toggle]');
        if (monoToggle && monoToggle.checked) {
          var monoRoot = document.querySelector('[data-monogram-fields]');
          if (monoRoot) {
            monoRoot.querySelectorAll('input[name^="properties["], select[name^="properties["]').forEach(function(input) {
              var val = input.value ? input.value.trim() : '';
              if (val) {
                var match = input.name.match(/^properties\[(.+?)\]$/);
                if (match) mainProps[match[1]] = val;
              }
            });
          }
        }
      } catch (err) {}

      /* Special Instructions */
      try {
        var ta = document.querySelector('[data-instructions-textarea]');
        if (ta && ta.value.trim()) mainProps['Special Instructions'] = ta.value.trim();
      } catch (err) {}

      /* Aria EZS size property (single-variant products with size dropdown) */
      try {
        var ariaSize = document.querySelector('[data-aria-size]');
        if (ariaSize && ariaSize.value) mainProps['Size'] = ariaSize.value;
      } catch (err) {}

      /* Strip internal props */
      for (var key in mainProps) {
        if (key.charAt(0) === '_' || !mainProps[key]) delete mainProps[key];
      }

      return mainProps;
    }
  };


  /* ═══════════════════════
     EZS VARIANT SELECT
     ═══════════════════════ */

  Luxire.EZS = {
    init: function() {
      var sel = document.querySelector('[data-variant-select]');
      if (!sel) return;
      sel.addEventListener('change', function() {
        var idInput = document.querySelector('[data-variant-id]');
        if (idInput) idInput.value = sel.value;
        try {
          var json = JSON.parse(document.querySelector('[data-product-json]').textContent);
          var v = json.variants.find(function(vr) { return vr.id == sel.value; });
          if (v) {
            var priceNum = (v.price / 100).toFixed(2);
            if (Luxire.Pricing.useCommaDecimal) priceNum = priceNum.replace('.', ',');
            var p = Luxire.Pricing.currencyPrefix + priceNum + (Luxire.Pricing.currencySuffix ? ' ' + Luxire.Pricing.currencySuffix : '');
            var pe = document.querySelector('[data-base-price]');
            var te = document.querySelector('[data-total-price]');
            var fp = document.querySelector('[data-floating-bar-price]');
            if (pe) pe.textContent = p;
            if (te) te.textContent = p;
            if (fp) fp.textContent = p;

            /* Update cart button disabled / sold-out state */
            var btn = document.querySelector('.product-cart-section__btn');
            if (btn) {
              btn.disabled = !v.available;
              btn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
            }
          }
        } catch (e) { /* Product JSON not available */ }
      });
    }
  };


  /* ═══════════════════════
     PROFILE SELECTOR
     Loads saved measurement & style profiles from LuxireStorage (AccountHub)
     and populates selectors on the product page.
     ═══════════════════════ */

  Luxire.ProfileSelector = {
    getStore: function() {
      return (typeof LuxireStorage !== 'undefined') ? LuxireStorage.getAccountHub() : {};
    },

    getMeasProfiles: function() {
      return (typeof LuxireStorage !== 'undefined') ? LuxireStorage.getMeasurementProfilesSync() : [];
    },
    getStyleProfiles: function() {
      return (typeof LuxireStorage !== 'undefined') ? LuxireStorage.getStyleProfilesSync() : [];
    },

    init: function() {
      this.initMeasSelector();
      this.initStyleSelector();
    },

    /* ── Measurement Profile Selector ── */
    initMeasSelector: function() {
      var select = document.getElementById('measProfileSelect');
      var emptyEl = document.getElementById('measProfileEmpty');
      var hasEl = document.getElementById('measProfileHas');
      if (!select) return;

      var profiles = this.getMeasProfiles();
      if (profiles.length === 0) {
        if (emptyEl) emptyEl.style.display = '';
        if (hasEl) hasEl.style.display = 'none';
        return;
      }

      /* Show selector, hide empty state */
      if (emptyEl) emptyEl.style.display = 'none';
      if (hasEl) hasEl.style.display = '';

      /* Populate dropdown */
      profiles.forEach(function(p, i) {
        var opt = document.createElement('option');
        opt.value = i;
        opt.textContent = p.name + (p.isDefault ? ' ★' : '');
        select.appendChild(opt);
      });

      /* Auto-select default */
      var defaultIdx = profiles.findIndex(function(p) { return p.isDefault; });
      if (defaultIdx >= 0) {
        select.value = defaultIdx;
        this.onMeasProfileSelect(defaultIdx);
      }

      var self = this;
      select.addEventListener('change', function() {
        var idx = select.value;
        self.onMeasProfileSelect(idx !== '' ? parseInt(idx) : -1);
      });
    },

    onMeasProfileSelect: function(idx) {
      var preview = document.getElementById('measProfilePreview');
      var hidden = document.getElementById('measProfileHidden');
      if (!preview) return;

      if (idx < 0) {
        preview.style.display = 'none';
        if (hidden) hidden.value = '';
        return;
      }

      var profiles = this.getMeasProfiles();
      var p = profiles[idx];
      if (!p) return;

      if (hidden) hidden.value = p.name;

      /* Build preview grid */
      var m = p.measurements || {};
      var unit = p.unit === 'cm' ? ' cm' : '"';
      var groups = this._groupMeasurements(m);
      var html = '<div class="mp-profile-preview__name">' + this._esc(p.name) + '</div>';
      html += '<div class="mp-profile-preview__grid">';
      groups.forEach(function(g) {
        html += '<div class="mp-profile-preview__group-title">' + g.title + '</div>';
        g.rows.forEach(function(r) {
          html += '<div class="mp-profile-preview__row"><span class="mp-profile-preview__key">' + r.label + '</span><span class="mp-profile-preview__val">' + this._esc(r.value) + unit + '</span></div>';
        }.bind(this));
      }.bind(this));
      html += '</div>';
      if (m.fit_notes) {
        html += '<div class="mp-profile-preview__notes"><strong>Fit notes:</strong> ' + this._esc(m.fit_notes) + '</div>';
      }
      preview.innerHTML = html;
      preview.style.display = '';

      /* Also inject measurements as hidden fields for order properties */
      this._injectMeasHiddenFields(p);
    },

    _injectMeasHiddenFields: function(profile) {
      /* Remove any previously injected fields */
      document.querySelectorAll('.mp-injected-field').forEach(function(el) { el.remove(); });

      var m = profile.measurements || {};
      var container = document.getElementById('measProfileSelector');
      if (!container) return;

      /* Map profile keys to order property names */
      var keyMap = {
        body_height: 'Height', body_weight: 'Weight',
        shirt_neck: 'Neck', shirt_chest: 'Chest', shirt_waist: 'Shirt Waist', shirt_hips: 'Shirt Hips',
        shirt_shoulder: 'Shoulder', shirt_sleeve: 'Sleeve Length', shirt_bicep: 'Bicep', shirt_wrist: 'Wrist',
        shirt_front_length: 'Shirt Front Length', shirt_back_length: 'Shirt Back Length',
        shirt_yoke: 'Yoke Width', shirt_elbow: 'Elbow',
        trouser_waist: 'Pant Waist', trouser_seat: 'Pant Hip', trouser_front_rise: 'Pant Front Rise',
        trouser_back_rise: 'Pant Back Rise', trouser_thigh: 'Pant Thigh', trouser_mid_thigh: 'Pant Mid Thigh',
        trouser_knee: 'Pant Knee', trouser_bottom: 'Pant Bottom Opening',
        trouser_inseam: 'Pant Inseam', trouser_outseam: 'Pant Outseam',
        trouser_calf: 'Pant Calf', trouser_crotch_width: 'Crotch Width',
        jacket_chest: 'Jacket Chest', jacket_waist: 'Jacket Waist',
        jacket_shoulder: 'Jacket Shoulder', jacket_length: 'Jacket Length',
        jacket_sleeve: 'Jacket Sleeve', jacket_half_back: 'Half Back Width',
        jacket_bicep: 'Jacket Bicep', jacket_front_length: 'Jacket Front Length',
        fit_notes: 'Fit Notes', ref_orders: 'Reference Orders'
      };

      Object.keys(m).forEach(function(key) {
        if (!m[key]) return;
        var propName = keyMap[key] || key.replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + propName + ']';
        input.value = m[key];
        input.className = 'mp-injected-field';
        container.appendChild(input);
      });
    },

    _groupMeasurements: function(m) {
      var groups = [];
      var self = this;
      var shirtKeys = Object.keys(m).filter(function(k) { return k.indexOf('shirt_') === 0 && m[k]; });
      var trouserKeys = Object.keys(m).filter(function(k) { return k.indexOf('trouser_') === 0 && m[k]; });
      var jacketKeys = Object.keys(m).filter(function(k) { return k.indexOf('jacket_') === 0 && m[k]; });
      var bodyKeys = Object.keys(m).filter(function(k) { return k.indexOf('body_') === 0 && m[k]; });

      if (bodyKeys.length) groups.push({ title: 'Body', rows: bodyKeys.map(function(k) { return { label: self._keyLabel(k), value: m[k] }; }) });
      if (shirtKeys.length) groups.push({ title: 'Shirt', rows: shirtKeys.map(function(k) { return { label: self._keyLabel(k), value: m[k] }; }) });
      if (trouserKeys.length) groups.push({ title: 'Trouser', rows: trouserKeys.map(function(k) { return { label: self._keyLabel(k), value: m[k] }; }) });
      if (jacketKeys.length) groups.push({ title: 'Jacket', rows: jacketKeys.map(function(k) { return { label: self._keyLabel(k), value: m[k] }; }) });
      return groups;
    },

    _keyLabel: function(key) {
      return key.replace(/^(shirt_|trouser_|jacket_|body_)/, '').replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
    },

    _esc: function(s) {
      if (!s) return '';
      var el = document.createElement('span');
      el.textContent = s;
      return el.innerHTML;
    },

    /* ── Style Profile Selector ── */
    initStyleSelector: function() {
      var bar = document.getElementById('styleProfileBar');
      var select = document.getElementById('styleProfileSelect');
      if (!bar || !select) return;

      var garmentType = bar.dataset.garmentType;
      var allProfiles = this.getStyleProfiles();

      /* Filter profiles matching this garment type */
      var profiles = [];
      allProfiles.forEach(function(p, i) {
        if (p.garmentType === garmentType) {
          profiles.push({ profile: p, idx: i });
        }
        /* Suit profiles also match jacket and trouser */
        if (garmentType === 'suit' && (p.garmentType === 'jacket' || p.garmentType === 'trouser')) {
          profiles.push({ profile: p, idx: i });
        }
      });

      if (profiles.length === 0) return;

      /* Show bar and populate options */
      bar.style.display = '';
      profiles.forEach(function(item) {
        var opt = document.createElement('option');
        opt.value = item.idx;
        opt.textContent = item.profile.name + ' (' + item.profile.garmentType + ')';
        select.appendChild(opt);
      });

      var self = this;
      select.addEventListener('change', function() {
        var idx = select.value;
        if (idx === '') {
          self.clearStyleProfile();
          return;
        }
        self.applyStyleProfile(parseInt(idx));
      });

      /* Clear button */
      var clearBtn = document.getElementById('styleProfileClear');
      if (clearBtn) {
        clearBtn.addEventListener('click', function() { self.clearStyleProfile(); });
      }
    },

    applyStyleProfile: function(idx) {
      var profiles = this.getStyleProfiles();
      var p = profiles[idx];
      if (!p) return;

      var hidden = document.getElementById('styleProfileHidden');
      var applied = document.getElementById('styleProfileApplied');
      var inner = document.querySelector('.style-profile-bar__inner');
      var nameEl = document.getElementById('styleProfileName');

      if (hidden) hidden.value = p.name;
      if (nameEl) nameEl.textContent = p.name + ' applied';
      if (applied) applied.style.display = '';
      if (inner) inner.style.display = 'none';

      /* Switch to customize track */
      Luxire.Fork.setTrack('customize');

      /* Apply each style to matching wizard step */
      var styles = p.styles || {};
      var applied_count = 0;

      Object.keys(styles).forEach(function(styleKey) {
        var value = styles[styleKey];
        if (!value) return;

        /* Try to find a matching wizard step by property name */
        /* Style key is like 'trouser_front_pleats' or 'shirt_collar_style' */
        /* Wizard step property is like 'Front Pleats' or 'Collar' */
        var steps = document.querySelectorAll('[data-step-property]');
        steps.forEach(function(step) {
          var stepProp = step.dataset.stepProperty;

          /* Try multiple matching strategies */
          var normalizedKey = styleKey.replace(/^(shirt_|trouser_|jacket_|suit_)/, '').replace(/_/g, ' ');
          var normalizedProp = stepProp.toLowerCase();

          if (normalizedProp.indexOf(normalizedKey) >= 0 || normalizedKey.indexOf(normalizedProp.replace(/ /g, '_')) >= 0) {
            /* Found a matching step — try to click the matching option */
            var options = step.querySelectorAll('[data-option][data-value]');
            options.forEach(function(opt) {
              var optVal = opt.dataset.value.toLowerCase();
              var targetVal = value.toLowerCase();
              if (optVal === targetVal || optVal.indexOf(targetVal) >= 0 || targetVal.indexOf(optVal) >= 0) {
                opt.click();
                applied_count++;
              }
            });
          }
        });
      });

      /* Also submit style values as hidden properties for the order */
      document.querySelectorAll('.sp-injected-field').forEach(function(el) { el.remove(); });
      var bar = document.getElementById('styleProfileBar');
      Object.keys(styles).forEach(function(key) {
        if (!styles[key]) return;
        var propName = key.replace(/^(shirt_|trouser_|jacket_|suit_)/, '').replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Style: ' + propName + ']';
        input.value = styles[key];
        input.className = 'sp-injected-field';
        bar.appendChild(input);
      });
    },

    clearStyleProfile: function() {
      var hidden = document.getElementById('styleProfileHidden');
      var applied = document.getElementById('styleProfileApplied');
      var inner = document.querySelector('.style-profile-bar__inner');
      var select = document.getElementById('styleProfileSelect');

      if (hidden) hidden.value = '';
      if (applied) applied.style.display = 'none';
      if (inner) inner.style.display = '';
      if (select) select.value = '';

      /* Remove injected hidden fields */
      document.querySelectorAll('.sp-injected-field').forEach(function(el) { el.remove(); });
    }
  };


  /* ═══════════════════════
     INIT — single DOMContentLoaded handler
     ═══════════════════════ */

  document.addEventListener('DOMContentLoaded', function() {
    var _init = function(name, fn) { try { fn(); } catch(e) { console.error('[Luxire] ' + name + ' init failed:', e); } };

    _init('Gallery',         function() { Luxire.Gallery.init(); });
    _init('Fork',            function() { Luxire.Fork.init(); });
    _init('Wizard',          function() { Luxire.Wizard.init(); });
    _init('Measurements',    function() { Luxire.Measurements.init(); });
    _init('ProfileSelector', function() { Luxire.ProfileSelector.init(); });
    _init('Monogram',        function() { Luxire.Monogram.init(); });
    _init('Instructions',    function() { Luxire.Instructions.init(); });
    _init('Tabs',            function() { Luxire.Tabs.init(); });
    _init('FloatingBar',     function() { Luxire.FloatingBar.init(); });
    _init('Pricing',         function() { Luxire.Pricing.init(); });
    _init('EZS',             function() { Luxire.EZS.init(); });
    _init('updateProperties',function() { Luxire.Pricing.updateProperties(); });
    _init('SmartHelp',       function() { Luxire.SmartHelp.init(); });

    /* Cart edit must run last, after all modules are initialized */
    _init('CartEdit', function() { Luxire.CartEdit.init(); });
  });


  /* ═══════════════════════
     CART EDIT
     Restores selections from cart on product page,
     then swaps old line item on submit.
     ═══════════════════════ */

  Luxire.CartEdit = {
    editKey: null,

    init: function() {
      var params = new URLSearchParams(window.location.search);
      var editKey = params.get('cart_edit');
      if (!editKey) return;

      var raw;
      try { raw = sessionStorage.getItem('luxire_cart_edit'); } catch (e) { return; }
      if (!raw) return;

      var data;
      try { data = JSON.parse(raw); } catch (e) { return; }
      if (!data || data.cartKey !== editKey) return;

      this.editKey = editKey;
      var props = data.properties || {};

      /* ── 1. Set fork track ── */
      if (props['Style'] === 'Custom') {
        Luxire.Fork.setTrack('customize');
      }

      /* ── 2. Pre-select wizard options ── */
      var wiz = document.querySelector('[data-wizard]');
      if (wiz) {
        wiz.querySelectorAll('[data-wizard-step]').forEach(function(step) {
          var propName = step.dataset.stepProperty;
          if (!propName || !props[propName]) return;
          var target = props[propName];
          var opt = step.querySelector('[data-option][data-value="' + CSS.escape(target) + '"]');
          if (opt) Luxire.Wizard._selectOption(opt);
        });
        /* Walk through all steps to mark them completed */
        if (Luxire.Wizard.total > 0) {
          for (var s = 1; s <= Luxire.Wizard.total; s++) {
            Luxire.Wizard.goTo(s);
          }
          /* Complete and collapse to final state */
          Luxire.Wizard._completeAll();
        }
      }

      /* ── 3. Set measurement method + fill values ── */
      var methodMap = {
        'Saved Profile': 'saved',
        'Garment Measurements': 'garment',
        'Body Measurements': 'body',
        'Standard Size': 'standard',
        'Send Garment': 'send'
      };
      var method = methodMap[props['Measurement Method']];
      if (method) {
        Luxire.Measurements.setMethod(method);
      }

      /* Fill measurement inputs in the active panel */
      setTimeout(function() {
        var panel = document.querySelector('.measurement-panel.is-active');
        if (panel) {
          panel.querySelectorAll('input[name^="properties["], select[name^="properties["]').forEach(function(input) {
            /* Extract property name from name="properties[Pant Waist]" */
            var match = input.name.match(/properties\[(.+?)\]/);
            if (match && props[match[1]]) {
              input.value = props[match[1]];
            }
          });
        }
      }, 50);

      /* ── 4. Monogram ── */
      if (props['Monogram Initials']) {
        var toggle = document.querySelector('[data-monogram-toggle]');
        var fields = document.querySelector('[data-monogram-fields]');
        if (toggle && fields) {
          toggle.checked = true;
          fields.classList.add('is-open');
        }
        var initialsInput = document.querySelector('#monogram-initials');
        if (initialsInput) initialsInput.value = props['Monogram Initials'];

        if (props['Monogram Color']) {
          var colorBtn = document.querySelector('[data-monogram-colors] [data-color="' + props['Monogram Color'] + '"]');
          if (colorBtn) {
            document.querySelectorAll('[data-monogram-colors] [data-color]').forEach(function(c) { c.classList.remove('is-selected'); });
            colorBtn.classList.add('is-selected');
          }
          var colorField = document.querySelector('[data-monogram-color-field]');
          if (colorField) colorField.value = props['Monogram Color'];
        }
        if (props['Monogram Placement']) {
          var placementSel = document.querySelector('#monogram-placement');
          if (placementSel) placementSel.value = props['Monogram Placement'];
        }
        if (props['Monogram Font']) {
          var fontSel = document.querySelector('#monogram-font');
          if (fontSel) fontSel.value = props['Monogram Font'];
        }
      }

      /* ── 5. Special Instructions ── */
      if (props['Special Instructions']) {
        var ta = document.querySelector('[data-instructions-textarea]');
        if (ta) ta.value = props['Special Instructions'];
        /* Activate matching chips */
        document.querySelectorAll('[data-chip]').forEach(function(chip) {
          if (props['Special Instructions'].indexOf(chip.dataset.chip) !== -1) {
            chip.classList.add('is-active');
          }
        });
      }

      /* ── 6. Update UI to "edit mode" ── */
      var atcBtn = document.querySelector('.product-cart-section__btn');
      if (atcBtn) {
        atcBtn.textContent = 'Update Cart Item';
        atcBtn.classList.add('product-cart-section__btn--edit');
      }
      var floatBtn = document.querySelector('[data-floating-bar-atc]');
      if (floatBtn) floatBtn.textContent = 'Update Cart Item';

      /* Show edit banner */
      var cartSection = document.querySelector('.product-cart-section');
      if (cartSection) {
        var banner = document.createElement('div');
        banner.className = 'cart-edit-banner';
        banner.innerHTML = '<span>✎ Editing cart item</span><a href="/cart" class="cart-edit-banner__cancel">Cancel</a>';
        cartSection.insertBefore(banner, cartSection.firstChild);
      }

      /* ── 7. Intercept form submit: remove old → add new ── */
      this._interceptSubmit();

      /* Clean URL without reloading */
      var cleanUrl = window.location.pathname;
      try { history.replaceState(null, '', cleanUrl); } catch (e) { /* ignore */ }
    },

    _interceptSubmit: function() {
      /* No longer needed — Pricing.init handles form submit and calls _doEditSubmit */
    },

    _doEditSubmit: function(form) {
      var self = this;
      if (!self.editKey) return;

      var btn = form.querySelector('.product-cart-section__btn');
      if (btn) { btn.disabled = true; btn.textContent = 'Updating…'; }

      /* Build properties directly (same approach as addToCartWithSurcharges) */
      var mainProps = Luxire.Pricing.collectProperties();

      var mainVariantId = form.querySelector('[name="id"]').value;
      var items = [{
        id: parseInt(mainVariantId, 10),
        quantity: 1,
        properties: mainProps
      }];

      /* Add surcharge items */
      var pricing = Luxire.Pricing.calculate();
      var titleEl = document.querySelector('.product-info__title');
      var productName = titleEl ? titleEl.textContent.trim() : 'Custom Garment';
      var productHandle = (titleEl && titleEl.dataset.productHandle) || '';

      pricing.surchargeItems.forEach(function(sur) {
        /* Never add shipping-type surcharges — these are obsolete */
        if (sur.type === 'shipping') return;

        var variants = Luxire.SurchargeVariants.decompose(sur.amount);
        variants.forEach(function(v) {
          var props = { '_surcharge_for': productName, '_surcharge_for_handle': productHandle, '_surcharge_type': sur.type };
          if (sur.type === 'upgrade') props['Upgrade'] = sur.label + ' (+' + (Luxire.Pricing.currencyPrefix || '$') + sur.amount + ')';
          else if (sur.type === 'construction') props['Construction'] = sur.label;
          else if (sur.type === 'service') props['Service'] = sur.label;
          else if (sur.type === 'monogram') props['Monogram'] = 'Personalization';
          items.push({ id: v.id, quantity: 1, properties: props });
        });
      });

      /* Step 1: Remove old item (and any associated surcharges) */
      fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        /* Find and remove old surcharge items linked to this product */
        var removePromises = [];

        /* Remove the main edited item */
        removePromises.push(
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: self.editKey, quantity: 0 })
          })
        );

        /* Also remove any surcharge items that reference this product (match by handle or title) */
        cart.items.forEach(function(cartItem) {
          if (cartItem.product_type === 'Surcharge') {
            var surFor = cartItem.properties && cartItem.properties['_surcharge_for'];
            var surHandle = cartItem.properties && cartItem.properties['_surcharge_for_handle'];
            if ((productHandle && surHandle === productHandle) || surFor === productName) {
              removePromises.push(
                fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: cartItem.key, quantity: 0 })
                })
              );
            }
          }
        });

        return Promise.all(removePromises);
      })
      .then(function() {
        /* Step 2: Add updated items */
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function() {
        try { sessionStorage.removeItem('luxire_cart_edit'); } catch (e) {}
        window.location.href = '/cart';
      })
      .catch(function(err) {
        if (btn) { btn.disabled = false; btn.textContent = 'Update Cart Item'; }
        alert('Error updating item. Please try again.');
        console.error('Cart edit error:', err);
      });
    }
  };


  /* ═══════════════════════
     SMART HELP — Bottom sheet, nudge bars, context hints
     Layered help system: micro-desc (always visible),
     nudge (social proof), bottom sheet (deep dive)
     ═══════════════════════ */

  Luxire.SmartHelp = {
    sheetTarget: null,

    init: function() {
      var self = this;
      this._createSheet();

      /* Nudge bar clicks → select that option */
      document.querySelectorAll('[data-nudge-value]').forEach(function(nudge) {
        nudge.addEventListener('click', function() {
          var step = nudge.closest('[data-wizard-step]');
          if (!step) return;
          var opt = step.querySelector('[data-option][data-value="' + nudge.dataset.nudgeValue + '"]');
          if (opt) {
            Luxire.Wizard._selectOption(opt);
            /* Flash feedback */
            nudge.style.background = 'rgba(58,125,68,0.15)';
            setTimeout(function() { nudge.style.background = ''; }, 300);
          }
        });
      });

      /* Detail ⓘ buttons → open sheet */
      document.querySelectorAll('.wizard__option-detail-btn').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          self.openSheet(btn.closest('[data-option]'));
        });
      });

      /* Context hints — run after each selection */
      this._patchWizardSelect();
    },

    _createSheet: function() {
      var self = this;
      if (document.getElementById('wizardSheet')) return;

      var overlay = document.createElement('div');
      overlay.className = 'wizard__sheet-overlay';
      overlay.id = 'wizardSheetOverlay';

      var sheet = document.createElement('div');
      sheet.className = 'wizard__sheet';
      sheet.id = 'wizardSheet';
      sheet.innerHTML =
        '<div class="wizard__sheet-handle"></div>' +
        '<button class="wizard__sheet-close" type="button">✕</button>' +
        '<div class="wizard__sheet-carousel" id="wizSheetCarousel"></div>' +
        '<div class="wizard__sheet-dots" id="wizSheetDots"></div>' +
        '<div class="wizard__sheet-body">' +
          '<h3 class="wizard__sheet-title" id="wizSheetTitle"></h3>' +
          '<div id="wizSheetBadge" style="margin-bottom:8px;"></div>' +
          '<p class="wizard__sheet-desc" id="wizSheetDesc"></p>' +
          '<button class="wizard__sheet-select" id="wizSheetSelect" type="button">Select this option</button>' +
        '</div>';

      document.body.appendChild(overlay);
      document.body.appendChild(sheet);

      overlay.addEventListener('click', function() { self.closeSheet(); });
      sheet.querySelector('.wizard__sheet-close').addEventListener('click', function() { self.closeSheet(); });
      document.getElementById('wizSheetSelect').addEventListener('click', function() {
        if (self.sheetTarget) Luxire.Wizard._selectOption(self.sheetTarget);
        self.closeSheet();
      });

      /* Swipe-to-close */
      var startY = 0, curY = 0;
      sheet.addEventListener('touchstart', function(e) { startY = e.touches[0].clientY; }, { passive: true });
      sheet.addEventListener('touchmove', function(e) {
        curY = e.touches[0].clientY;
        var d = curY - startY;
        if (d > 0) sheet.style.transform = 'translateY(' + d + 'px)';
      }, { passive: true });
      sheet.addEventListener('touchend', function() {
        if (curY - startY > 80) self.closeSheet();
        sheet.style.transform = '';
        startY = 0; curY = 0;
      });

      /* ESC key */
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') self.closeSheet();
      });
    },

    openSheet: function(optEl) {
      if (!optEl) return;
      var desc = optEl.dataset.optionDesc || '';
      /* Gather images: data-option-imgs (pipe-delimited) or single img */
      var imgs = [];
      if (optEl.dataset.optionImgs) {
        imgs = optEl.dataset.optionImgs.split('|');
      } else if (optEl.dataset.optionImg) {
        imgs = [optEl.dataset.optionImg];
      } else {
        var singleImg = optEl.querySelector('.wizard__option-thumb img, [data-option-img] img');
        if (singleImg && singleImg.src) imgs = [singleImg.src.replace(/width=\d+/, 'width=500')];
      }
      if (!desc && !imgs.length) return;

      this.sheetTarget = optEl;

      /* Title */
      var nameEl = optEl.querySelector('.wizard__option-name') || optEl.querySelector('.wizard__option-label');
      var title = nameEl ? nameEl.textContent.replace(/Popular|Upgrade|Premium|Formal|Casual|Signature|Classic/gi, '').trim() : '';
      document.getElementById('wizSheetTitle').textContent = title;
      document.getElementById('wizSheetDesc').textContent = desc;

      /* Carousel */
      var carouselWrap = document.getElementById('wizSheetCarousel');
      var dotsWrap = document.getElementById('wizSheetDots');
      carouselWrap.innerHTML = '';
      dotsWrap.innerHTML = '';
      if (imgs.length) {
        imgs.forEach(function(url, i) {
          var img = document.createElement('img');
          img.className = 'wizard__sheet-img' + (i === 0 ? ' is-active' : '');
          img.src = url.replace(/width=\d+/, 'width=500');
          if (url.indexOf('width=') < 0 && url.indexOf('?') > -1) img.src = url + '&width=500';
          else if (url.indexOf('width=') < 0) img.src = url + '?width=500';
          img.alt = title + ' view ' + (i + 1);
          img.dataset.idx = i;
          carouselWrap.appendChild(img);

          if (imgs.length > 1) {
            var dot = document.createElement('button');
            dot.className = 'wizard__sheet-dot' + (i === 0 ? ' is-active' : '');
            dot.dataset.idx = i;
            dot.type = 'button';
            dot.addEventListener('click', function() {
              carouselWrap.querySelectorAll('img').forEach(function(s) { s.classList.remove('is-active'); s.style.display = 'none'; });
              dotsWrap.querySelectorAll('.wizard__sheet-dot').forEach(function(d) { d.classList.remove('is-active'); });
              var target = carouselWrap.querySelector('[data-idx="' + dot.dataset.idx + '"]');
              if (target) { target.classList.add('is-active'); target.style.display = ''; }
              dot.classList.add('is-active');
            });
            dotsWrap.appendChild(dot);
          }
        });
      }

      /* Badge */
      var badge = optEl.querySelector('.wizard__badge');
      document.getElementById('wizSheetBadge').innerHTML = badge ? badge.outerHTML : '';

      /* Surcharge */
      var surEl = optEl.querySelector('.wizard__option-surcharge');
      var selectBtn = document.getElementById('wizSheetSelect');
      if (surEl && surEl.textContent.trim()) {
        selectBtn.textContent = 'Select this option (' + surEl.textContent.trim() + ')';
      } else {
        selectBtn.textContent = 'Select this option';
      }

      document.getElementById('wizardSheetOverlay').classList.add('is-open');
      document.getElementById('wizardSheet').classList.add('is-open');
      document.body.classList.add('is-scroll-locked');
    },

    closeSheet: function() {
      document.getElementById('wizardSheetOverlay').classList.remove('is-open');
      document.getElementById('wizardSheet').classList.remove('is-open');
      document.body.classList.remove('is-scroll-locked');
      this.sheetTarget = null;
    },

    /* Patch wizard select to fire context hints after each selection */
    _patchWizardSelect: function() {
      var origSelect = Luxire.Wizard._selectOption.bind(Luxire.Wizard);
      var self = this;
      Luxire.Wizard._selectOption = function(optBtn) {
        origSelect(optBtn);
        self._runContextHints();
      };
      /* Run once on init */
      this._runContextHints();
    },

    /** Context hints — show pairing suggestions based on prior choices */
    _runContextHints: function() {
      var sel = Luxire.Wizard.selections;
      document.querySelectorAll('[data-context-hint]').forEach(function(card) {
        var rules = card.dataset.contextHint.split(';'); /* format: "property=value|text" */
        var visible = false;
        var textEl = card.querySelector('.wizard__context-card__text');
        for (var i = 0; i < rules.length; i++) {
          var parts = rules[i].split('|');
          if (parts.length < 2) continue;
          var condition = parts[0].split('=');
          if (condition.length < 2) continue;
          var prop = condition[0].trim();
          var val = condition[1].trim();
          if (sel[prop] && sel[prop].value === val) {
            if (textEl) textEl.innerHTML = parts[1];
            visible = true;
            break;
          }
        }
        card.classList.toggle('is-visible', visible);
      });
    }
  };

  /* ═══════════════════════
     RECENTLY VIEWED TRACKING
     Stores last 10 viewed products via LuxireStorage
     for use on 404 page, homepage, etc.
     ═══════════════════════ */
  (function trackRecentlyViewed() {
    try {
      var titleEl = document.querySelector('.product-info__title, h1.product-hero__title');
      var imgEl = document.querySelector('.product-gallery__main img, .product-hero__image img');
      var priceEl = document.querySelector('[data-product-price]');
      if (!titleEl) return;

      var item = {
        url: window.location.pathname,
        title: (titleEl.textContent || '').trim(),
        image: imgEl ? imgEl.src : '',
        price: priceEl ? (priceEl.textContent || '').trim() : ''
      };

      var stored = (typeof LuxireStorage !== 'undefined') ? LuxireStorage.getRecentlyViewed() : [];
      stored = stored.filter(function(s) { return s.url !== item.url; });
      stored.unshift(item);
      stored = stored.slice(0, 10);
      if (typeof LuxireStorage !== 'undefined') { LuxireStorage.saveRecentlyViewed(stored); }
    } catch(e) { /* silent */ }
  })();

})();
